import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=15718fe0"
import script from "./EmptyLayout.js?vue&type=script&lang=js&external"
export * from "./EmptyLayout.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports